module.exports = __webpack_public_path__ + "img/random-ia.e443aa7e.svg";